
<style scoped lang="scss">
.ticket-intro-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.65);
    z-index: 10000;
}
.ticket-intro-container {
    position: fixed;
    left: 0px;
    bottom: 0;
    width: 100%;
    background: $white;
    z-index: 10001;
    display: flex;
    flex-direction: column;
    height: $modal-height;
    white-space: pre-line;
    word-break: break-word;
    overflow: auto;
    -webkit-overflow-scrolling: touch;  
    .t-top {
        height: 1.146667rem;
        line-height: 1.146667rem;
        color: #666666;
        font-size:   0.426667rem;
        text-align: center;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        flex: none;
        .close {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 0;
            top: 0;
            width: 1.44rem;
            height: 100%;
            img {
                width: 0.426667rem;
                height: 0.426667rem;
            }
        }
    }
    .t-center {
        // height: 10.586667rem;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        flex: 1 1 auto;
        height: 100%;
        padding-bottom: 1.333333rem;
        .each-intro {
            padding-top: 0.533333rem;
            .intro-title {
                position: relative;
                padding-left: 0.3rem;
                font-size:   0.426667rem;
                color: #444;
                font-weight: bold;
                margin-bottom: 0.4rem;
            }
            .intro-row {
                margin-bottom: 0.4rem;
                font-size:  0.373333rem;
                padding: 0 0.373333rem;
                display: flex;
                .key {
                    color: #333;
                    min-width: 1.866667rem;
                }
                .value {
                    color: #808080;
                    padding-left: 0.14rem;
                    &.value-wra {
                        display: flex;
                        flex-direction: column;
                        span {
                            line-height: 1.6;
                            white-space: normal;
                        }
                    }
                }
            }
        }
    }
    .t-bottom {
        padding: 0.266667rem 0.533333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px -0.133333rem 0.266667rem rgba(0, 0, 0, 0.04);
        flex: none;
        .price {
            color: $orange;
            font-size: 0.56rem;
            font-weight: bold;
        }
        .yd-btn {
            &.no-stock {
                background: linear-gradient(90deg, #bbb9b9 0%, #888888 100%);
                box-shadow: 0 0 0.2rem 0px #bbb9b9;
                pointer-events: none;
            }
            background: $blue;
            line-height: 1.066667rem;
            width: 4.8rem;
            height: 1.066667rem;
            background: linear-gradient(
                90deg,
                rgba(248, 199, 64, 1) 0%,
                rgba(245, 149, 38, 1) 100%
            );
            box-shadow: 0 0 0.2rem 0px rgba(248, 199, 64, 0.49);
            border-radius: 0.533333rem;
            text-align: center;
            color: $white;
            font-size: 0.426667rem;
            font-weight: bold;
        }
    }
}
</style>

<template>
    <div>
        <transition name="fade">
            <div class="ticket-intro-wrapper" v-show="isOpen" @click.stop="closeModal"></div>
        </transition>
        <transition name="slideup">
            <div class="ticket-intro-container iphonex-adapt-padding" v-show="isOpen">
                <div class="t-center" id="modal_scroll_container">
                    <div class="each-intro">
                        <div class="intro-title">预定说明</div>
                        <div class="intro-row">
                            <span class="key">截止预订时间：</span>
                            <span
                                class="value"
                                v-if="introData.orderLimitDay && introData.orderLimitTime"
                            >使用日期前{{introData.orderLimitDay}}天{{introData.orderLimitTime}}后，不可预订</span>
                            <span class="value" v-else>所有日期内均可预订</span>
                        </div>
                    </div>
                    <div class="each-intro" v-if="introData.introduction">
                        <div class="intro-title">费用说明</div>
                        <div class="intro-row">
                            <span class="key" v-text="introData.introduction"></span>
                        </div>
                    </div>
                    <div class="each-intro" v-if="introData.refundRule">
                        <div class="intro-title">退款规则</div>
                        <div class="intro-row">
                            <span class="key" v-text="introData.refundRule"></span>
                        </div>
                    </div>
                    <div class="each-intro" v-if="introData.orderTip">
                        <div class="intro-title">预订须知</div>
                        <div class="intro-row">
                            <span class="key" v-text="introData.orderTip"></span>
                        </div>
                    </div>
                </div>
                <div class="t-bottom" v-if="isShowBottom">
                    <div
                        class="price"
                        v-if="introData.price || introData.price ===0"
                    >￥{{introData.price}}</div>
                    <div
                        class="yd-btn"
                        :class="{'no-stock':!introData.hasStock}"
                        @click="redirectToBuy(introData.id)"
                    >{{introData.hasStock ? '立即预订' : '暂无库存'}}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import MODAL_MIXINS from "@/components/common/ModalCommonMixins";
export default {
    name: "OrderIntroModal",
    components: {},
    mixins: [MODAL_MIXINS],
    props: {
        introData: Object,
        isShowBottom: Boolean,
        fromOrder: "",
        title: String,
        type: Number
        // list
    },
    data() {
        return {};
    },
    computed: {
        // resolvedTime() {
        //     let { beforeDay } = this.introData;
        //     if (beforeDay === "0") {
        //         //天数为0 时间不为空的情况
        //         return `今日可预订门票`;
        //     } else {
        //         return `提前${beforeDay}天可预订门票`;
        //     }
        // },
        // ap() {
        //     let ap = this.introData.availablePeriod;
        //     if (!ap) return [];
        //     return typeof ap === "string" ? JSON.parse(ap) : ap;
        // },
        // longAddress() {
        //     let x = "";
        //     if (this.introData.entrance) {
        //         this.introData.entrance.forEach((eachAdd, index, arr) => {
        //             x += `${eachAdd.province || ""}${eachAdd.city ||
        //                 ""}${eachAdd.district || ""}${eachAdd.address || ""}${
        //                 index + 1 === arr.length ? "" : "<br/>"
        //             }`;
        //         });
        //     } else {
        //         x = `${this.introData.province}${this.introData.city}${
        //             this.introData.district
        //         }${this.introData.address}`;
        //     }
        //     return x.trim();
        // },
        // limitText() {
        //     let { limitMax, limitMin } = this.introData;
        //     if (limitMax > 0) {
        //         if (limitMin > 0) {
        //             return `同一账号每次最多购买${limitMax}张,最少购买${limitMin}张`;
        //         } else {
        //             return `同一账号每次最多购买${limitMax}张`;
        //         }
        //     } else {
        //         if (limitMin > 0) {
        //             return `同一账号每次最少购买${limitMin}张`;
        //         } else {
        //             return ``;
        //         }
        //     }
        // }
    },
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        redirectToBuy(ticketId) {
            switch (this.type) {
                case 5:
                    this.$router.replace({
                        name: "routeOrder",
                        params: { ticketId }
                    });
                    break;
                case 6:
                    this.$router.replace({
                        name: "carOrder",
                        params: { ticketId }
                    });
                    break;
                case 11:
                    this.$router.replace({
                        name: "campingOrder",
                        params: { campingId:ticketId }
                    });
                    break;
                default:
                    break;
            }
        }
    }
};
</script>

